import { Fragment, React } from "react";
import About from "../About";
import BecomeProducer from "../BecomeProducer";
import Careers from "../Careers";
import Claims from "../Claims";
import Contact from "../Contact";
import Coverages from "../Coverages";
import GetQuote from "../GetQuote";
import Markets from "../Markets";
import NavBar from "../NavBar";
import PreferedVendors from "../PreferedVendors";
import Resources from "../Resources";
const Main = () => {
    return (
        <Fragment>
            <NavBar />
            <Coverages />
            <Markets />
            <About />
            <GetQuote />
            <BecomeProducer />
            <Contact />
            <Resources />
            <Claims />
            <Careers />
            <PreferedVendors />
        </Fragment>
    )
}
export default Main;